import type { WebformsFactory } from '@commons/pagebuilder/webforms';

import ContactUsWebform from './ContactUs';

/**
 * Enum of all available plugin webform ids for AiiA.
 *
 * Makes it easier to read and edit the ids.
 */

export enum AIIA_WEBFORM_ID {
  ContactUs = 'aiia_contact_us',
}

/**
 * Factory of all available webforms for AiiA.
 */

export const aiiaWebforms: WebformsFactory = {
  [AIIA_WEBFORM_ID.ContactUs]: ContactUsWebform,
};
